const RegularCustomer = () => {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='4' y='4' width='72' height='72' rx='36' fill='#DAD4FF' />
      <path
        d='M39.8608 16.171C47.5714 16.1711 53.8218 22.4224 53.8218 30.1329C53.8216 34.2585 52.0312 37.9649 49.186 40.5206C56.0212 41.5187 61.27 47.4047 61.27 54.5167V59.1144C61.2698 61.7182 59.159 63.829 56.5552 63.8292H23.4448C20.841 63.829 18.7302 61.7182 18.73 59.1144V54.5167C18.73 47.4876 23.8572 41.6563 30.5757 40.5577C27.7068 38.0008 25.9 34.2782 25.8999 30.1329C25.8999 22.4224 32.1503 16.171 39.8608 16.171ZM32.8755 45.0861C27.6673 45.0861 23.4448 49.3085 23.4448 54.5167V59.1144H56.5552V54.5167C56.5552 49.3085 52.3327 45.0861 47.1245 45.0861H32.8755ZM39.8608 20.8868C34.7544 20.8868 30.6147 25.0265 30.6147 30.1329C30.615 35.2392 34.7545 39.379 39.8608 39.379C44.9671 39.379 49.1067 35.2392 49.1069 30.1329C49.1069 25.0265 44.9673 20.8869 39.8608 20.8868Z'
        fill='#4F1787'
      />
    </svg>
  );
};

export default RegularCustomer;
